import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import CompanyInfo from '../views/CompanyInfo.vue'
import PassengersData from '../views/PassengersData.vue'
import LatestMovements from '../views/LatestMovements.vue'
import VehiclesData from '../views/VehiclesData.vue'
import QuickMessages from '../views/QuickMessages.vue'
import MapManagement from '../views/MapManagement.vue'

export default [
	{
		path: '/login',
		name: 'login',
		component: Login,
		i18nTitleKey: 'login'
	},
	{
		path: '/',
		name: 'home',
		component: Home,
		i18nTitleKey: 'home'
	},
	{
		path: '/company-info',
		name: 'company-info',
		component: CompanyInfo,
		i18nTitleKey: 'company-info'
	},
	{
		path: '/passengers-data',
		name: 'passengers-data',
		component: PassengersData,
		i18nTitleKey: 'passengers-data'
	},
	{
		path: '/latest-movements/:id',
		name: 'latest-movements',
		component: LatestMovements,
		i18nTitleKey: 'latest-movements'
	},
	{
		path: '/vehicles-data',
		name: 'vehicles-data',
		component: VehiclesData,
		i18nTitleKey: 'vehicles-data'
	},
	{
		path: '/quick-messages',
		name: 'quick-messages',
		component: QuickMessages,
		i18nTitleKey: 'quick-messages'
	},
	{
		path: '/map-management',
		name: 'map-management',
		component: MapManagement,
		i18nTitleKey: 'map-management'
	},
	{
		path: '*',
		redirect: '/'
	}
]